function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
import DanmakuAuxiliaryTemplate from '../../template/danmakuAuxiliary.art';
import DanmakuList from './danmakuList/danmakuList';
import AdvancedDanmakuEditor from './advancedDanmakuEditor/advancedDanmakuEditor';
var DanmakuAuxiliary = function () {
    function DanmakuAuxiliary(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, DanmakuAuxiliary);
        this.player = player;
        this.el = el;
        this.template = this.player.template;
        this.mount();
    }
    _createClass(DanmakuAuxiliary, [
        {
            key: 'mount',
            value: function mount() {
                this.el.classList.add('mfunsPlayer-danmaku-auxiliary');
                this.el.innerHTML = DanmakuAuxiliaryTemplate();
                var $ = this.el.querySelector.bind(this.el);
                this.template.danmaku_list_panel = $('.mfunsPlayer-danmaku-list-panel');
                this.template.ade_panel = $('.mfunsPlayer-ade-panel');
                this.template.ade_btn = $('.mfunsPlayer-ade-button');
                this.template.ade_exit_btn = $('.mfunsPlayer-ade-exit-button');
                this.danmakuList = new DanmakuList(this.player, this.template.danmaku_list_panel);
                this.advancedDanmakuEditor = new AdvancedDanmakuEditor(this.player, this.template.ade_panel);
                this.template.ade_btn.addEventListener('click', this.showADE.bind(this));
                this.template.ade_exit_btn.addEventListener('click', this.hideADE.bind(this));
            }
        },
        {
            key: 'showADE',
            value: function showADE() {
                this.template.danmaku_list_panel.style['display'] = 'none';
                this.template.ade_panel.style['display'] = '';
            }
        },
        {
            key: 'hideADE',
            value: function hideADE() {
                this.template.danmaku_list_panel.style['display'] = '';
                this.template.ade_panel.style['display'] = 'none';
            }
        }
    ]);
    return DanmakuAuxiliary;
}();
export default DanmakuAuxiliary;